import { useEffect, useState } from "react";
import { PaziaModal } from "components/molecules";
import { trainerFilesApi } from "api/trainers/trainerFilesApi";

interface TrainerFilePreviewModalProps {
  trainerId: number;
  fileId: number | null;
  fileName?: string;
  onCloseRequest: () => void;
}

export const TrainerFilePreviewModal = ({
  trainerId,
  fileId,
  fileName,
  onCloseRequest,
}: TrainerFilePreviewModalProps) => {
  const [preview, setPreview] = useState<{ url: string; contentType: string } | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (fileId == null) return;
    setPreview(null);
    setError(false);
    trainerFilesApi
      .getPreviewUrl(trainerId, fileId)
      .then((response) => setPreview(response.data))
      .catch(() => setError(true));
  }, [trainerId, fileId]);

  return (
    <PaziaModal
      id="trainer-file-preview-modal"
      onCloseRequest={() => {
        setPreview(null);
        setError(false);
        onCloseRequest();
      }}
      isOpen={fileId != null}
      size="7xl"
      className="h-full w-[90%] max-w-[90%]"
    >
      {error && (
        <div className="p-4 text-sm text-red-600">Nie udało się wczytać podglądu pliku.</div>
      )}
      {!error && !preview && <div className="p-4 text-sm text-slate-500">Wczytywanie…</div>}
      {preview?.contentType === "application/pdf" && (
        <object data={preview.url} type="application/pdf" width="100%" height="100%" />
      )}
      {(preview?.contentType === "image/jpeg" || preview?.contentType === "image/png") && (
        <img
          src={preview.url}
          alt={fileName ?? "Podgląd pliku"}
          className="w-full h-full object-contain"
        />
      )}
    </PaziaModal>
  );
};
